import { Divider, Flex, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Image } from '@chakra-ui/react'
import { Button as UbiButton, Icon } from '@ubirider/pick-component-library'
import { useTranslation } from 'react-i18next'
import { BlueSection } from './components/BlueSection'
import Invoice from './components/Invoice/Invoice'
import { VatTag } from './components/VatType/VatTag'
import { DateTime } from 'luxon'
import { userTimezone } from '../../../../../../App'

import editIcon from '../../../../../../assets/edit_purple.svg'
import visa from '../../../../../../assets/visa.svg'
import mastercard from '../../../../../../assets/mastercard_transparent.svg'
import amex from '../../../../../../assets/amex.svg'
import unionpay from '../../../../../../assets/unionpay.svg'
import discover from '../../../../../../assets/discover.svg'
import proximo from '../../../../../../assets/proximo.png'
import tub from '../../../../../../assets/tub.png'
import moravia from '../../../../../../assets/moravia.png'
import naher from '../../../../../../assets/naher.png'
import fertagus from '../../../../../../assets/fertagus.png'
import ubirider from '../../../../../../assets/ubirider.svg'
import libertybus from '../../../../../../assets/libertybus.png'
import trevo from '../../../../../../assets/trevo.png'
import pick from '../../../../../../assets/pick_logo.svg'
import placeholder from '../../../../../../assets/placeholder.svg'
import ChevronDown from '../../../../../../assets/arrow_down.svg'
import { useEffect, useState } from 'react'

export function Trip({ pickCard, billing, trip, onTrip, isChecked, onEdit }) {
  const { t } = useTranslation()

  const externalMerchant = trip.merchant !== 'UbiRider'
  const merchant = externalMerchant ? trip.merchant : trip.transport ? trip.transport + ' Company' : 'UbiRider'
  const transport = trip.transport
  const tripUsedPickCard = pickCard && pickCard.number.slice(-4) === trip.cardPAN.slice(-4)


  const [now, setNow] = useState(() => Date.now())
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000)
          return () => clearInterval(id)
        }, [])

      const isRecent = Math.abs(now - Number(trip?.date ?? 0)) <= 15000

  const detectCardBrand = firstSixDigits => {
    if (tripUsedPickCard) return pick
    switch (true) {
      case /^4/.test(firstSixDigits):
        return visa
      case /^5[1-5]/.test(firstSixDigits):
        return mastercard
      case /^(34|37)/.test(firstSixDigits):
        return amex
      case /^62/.test(firstSixDigits):
        return unionpay
      case /^6/.test(firstSixDigits):
        return discover
      default:
        return null
    }
  }

  return (
    <Accordion allowToggle onChange={onTrip}>
      <AccordionItem marginBlock='8px' rounded='4px'>
        {({ isExpanded }) => (
          <Flex
            bg={!externalMerchant && (isExpanded || isChecked)
              ? 'secondary.25'
              : (isRecent
                ? 'secondary.100'
                : 'neutral.25'
              )}
            rounded='4px'
            border='1px'
            borderColor={(isExpanded || isChecked) && !externalMerchant ? 'secondary.500' : 'neutral.300'}
            _hover={externalMerchant ? {
            } : {
              border: '1px',
              borderColor: 'secondary.500',
            }}
            direction='column'
            css={'box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1)'}
          >
            <AccordionButton
              p='16px'
              _hover={{}}
              _expanded={externalMerchant ? {} : {
                paddingBottom: '0px',
              }}
              cursor={externalMerchant ? 'default !important' : undefined }
            >
              <Flex flex='1' align='center'>
                <Text color='neutral.800' fontSize='13px' flex='3' textAlign='left'>
                  {DateTime.fromMillis(trip.date, { zone: 'utc' }).setZone(userTimezone).toFormat('dd/MM/yyyy HH:mm')}
                </Text>

                <Text fontSize='13px' flex='2' textAlign='left'>
                  {transport ? transport : '-'}
                </Text>

                <Flex flex='3' gap='8px' justifyContent='flex-start' align='center'>
                  <Icon src={detectCardBrand(trip.cardPAN.slice(0, 6))} fill={tripUsedPickCard ? '#7537FA' : undefined} />
                  <Text display={{ sm: 'none', md: 'flex' }} color='neutral.800' fontSize='13px'>
                    {`${t('travel_history.card')} **${trip.cardPAN.slice(-4)}`}
                  </Text>
                </Flex>

                <Flex flex='2' justifyContent='flex-start'>
                  {externalMerchant ? '-' : <VatTag text={trip.invoices[0]} name={billing} />}
                </Flex>

                <Flex flex='2' gap='8px' align='center' minWidth={0}>
                  <Image src={externalMerchant ? placeholder : ubirider} h='24px' />
                  <Text
                    fontSize='13px'
                    textAlign='left'
                    whiteSpace='nowrap'
                  >
                    {merchant ? merchant : '-'}
                  </Text>
                </Flex>

                <Text color='neutral.800' fontSize='13px' fontWeight='700' flex='2' textAlign='right'>
                  {(Math.round(trip.amount * 100) / 100).toFixed(2)}€
                </Text>

                <Flex flex='1' align='center' justify='flex-end' gap='13px' cursor={externalMerchant ? 'not-allowed' : 'pointer'}>
                  <Icon src={ChevronDown} fill={externalMerchant ? '#EAECF0' : undefined} flipped={isExpanded && !externalMerchant} />
                </Flex>
              </Flex>
            </AccordionButton>
            {!externalMerchant && (
              <AccordionPanel pl={{ sm: '', md: '64px', lg: '64px', xl: '64px' }} pr={{ sm: '', md: '48px', lg: '48px', xl: '48px' }}>
                <Divider color='neutral.300' />
                <Flex pt='8px'>
                  <Flex direction='column' flex='1'>
                    <Flex marginInline='8px' direction='column' flex='1' display={{ sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' }}>
                      <Text fontSize='14px' fontWeight='700'>
                        {t('travel_history.selected_trip')}
                      </Text>

                      <Flex justifyContent='space-between' gap='8px'>
                        <Flex gap='8px'>
                          <Text fontSize='13px'>{t('travel_history.origin_destination')}</Text>
                          <Text fontSize='13px' fontWeight='600'>
                            {trip.plannedOrigin} - {trip.plannedDestination}
                          </Text>
                        </Flex>
                        <Flex gap='8px'>
                          <Text fontSize='13px'>{t('travel_history.discount')}</Text>
                          <Text fontSize='13px' fontWeight='600'>
                            {(Math.round(trip.discount * 100) / 100).toFixed(2)}€
                          </Text>
                        </Flex>
                        <Flex gap='8px'>
                          <Text fontSize='13px'>{t('travel_history.total')}</Text>
                          <Text fontSize='13px' fontWeight='600'>
                            {isNaN(trip.plannedAmount) ? '- ' : (Math.round(trip.plannedAmount * 100) / 100).toFixed(2)}€
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>

                    <Flex gap='8px' padding='0 8px' direction='column' display={{ sm: 'flex', md: 'none', lg: 'none', xl: 'none' }}>
                      <Flex gap='4px' direction='column'>
                        <Text fontSize='14px' fontWeight='700'>
                          {t('travel_history.date')}
                        </Text>
                        <Flex gap='24px'>
                          <Text color='neutral.800' fontSize='13px'>
                            {DateTime.fromMillis(trip.date, {
                              zone: 'utc',
                            })
                              .setZone('Europe/Lisbon')
                              .toFormat('dd/MM/yyyy')}
                          </Text>
                          <Text color='neutral.800' fontSize='13px'>
                            {DateTime.fromMillis(trip.date, {
                              zone: 'utc',
                            })
                              .setZone('Europe/Lisbon')
                              .toFormat('HH:mm')}
                          </Text>
                        </Flex>
                      </Flex>
                      <Flex gap='4px' direction='column'>
                        <Text fontSize='14px' fontWeight='700'>
                          {t('common.card_number')}
                        </Text>
                        <Text fontSize='13px'>{trip.cardPAN.match(/.{1,4}/g).join(' ')}</Text>
                      </Flex>
                    </Flex>

                    <BlueSection origin={trip.origin} destination={trip.destination} amount={trip.amount} currency={'€'} />

                    <Flex justifyContent='space-between' gap='8px' padding='8px' direction='column' display={{ sm: 'flex', md: 'none', lg: 'none', xl: 'none' }}>
                      <Text fontSize='14px' fontWeight='700'>
                        {t('travel_history.selected_trip')}
                      </Text>
                      <Flex gap='4px' direction='column'>
                        <Text fontSize='13px'>{t('travel_history.origin_destination')}</Text>
                        <Text fontSize='13px' fontWeight='600'>
                          {trip.plannedOrigin} - {trip.plannedDestination}
                        </Text>
                      </Flex>
                      <Flex gap='4px' direction='column'>
                        <Text fontSize='13px'>{t('travel_history.discount')}</Text>
                        <Text fontSize='13px' fontWeight='600'>
                          {(Math.round(trip.discount * 100) / 100).toFixed(2)}€
                        </Text>
                      </Flex>
                      <Flex gap='4px' direction='column'>
                        <Text fontSize='13px'>{t('travel_history.total')}</Text>
                        <Text fontSize='13px' fontWeight='600'>
                          {isNaN(trip.plannedAmount) ? '- ' : (Math.round(trip.plannedAmount * 100) / 100).toFixed(2)}€
                        </Text>
                      </Flex>
                    </Flex>

                    <Flex gap='4px' marginInline='8px' align='center'>
                      <Text fontSize='13px' fontWeight='600'>
                        {t('common.tax_id')}
                      </Text>
                      <Text fontSize='13px' fontWeight='400'>
                        {trip?.invoices[0]?.vatNumber && trip?.invoices[0]?.vatNumber !== '-'
                          ? trip.invoices[0].vatNumber.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
                          : '999 999 999'}
                      </Text>
                      <UbiButton
                        disabled={trip?.invoices[0]?.invoiceName === undefined && trip?.invoiceName === undefined}
                        onClick={onEdit}
                        size='small'
                        style='ghost'
                        type='primary'
                        leftIconProps={{ src: editIcon }}
                      />
                    </Flex>

                    <Flex padding='8px 0 8px 8px' direction='column' gap='8px'>
                      <Flex alignItems='flex-start' gap='8px'>
                        <Text fontSize='13px' fontWeight='600'>
                          {t('travel_history.documents')}
                        </Text>
                      </Flex>
                      <Divider border='1px solid #D0D5DD' />
                      <Flex
                        alignItems='flex-start'
                        display={{
                          sm: 'none',
                          md: 'flex',
                          lg: 'flex',
                          xl: 'flex',
                        }}
                        flex='1'
                      >
                        <Flex flex='2'>
                          <Text fontSize='13px' color='#1D2939'>
                            {t('travel_history.date')}
                          </Text>
                        </Flex>
                        <Flex flex='3'>
                          <Text fontSize='13px' color='#1D2939'>
                            {t('travel_history.invoice')}
                          </Text>
                        </Flex>
                        <Flex flex='2'>
                          <Text fontSize='13px' color='#1D2939'>
                            {t('travel_history.status')}
                          </Text>
                        </Flex>
                        <Flex flex='3'>
                          <Text fontSize='13px' color='#1D2939'>
                            {t('travel_history.credit_note')}
                          </Text>
                        </Flex>
                      </Flex>
                      {trip.invoices.map((invoice, i) => (
                        <Invoice key={i} invoice={invoice} />
                      ))}
                    </Flex>
                  </Flex>
                </Flex>
              </AccordionPanel>
            )}
          </Flex>
        )}
      </AccordionItem>
    </Accordion>
  )
}
